import NewspaperSimpleForm from './NewspaperSimpleForm'

export default NewspaperSimpleForm
